module.exports = __webpack_public_path__ + "img/ls.9b482bab.jpg";